__turbopack_context__.v({
  "root": "ForClubsLandingContent-module-scss-module__qKH0SG__root",
  "simpleProcessBlock": "ForClubsLandingContent-module-scss-module__qKH0SG__simpleProcessBlock",
});
